import ApiService from "@/core/services/api.service";

export default {
  state: {
    letters: [],
    letter: ""
  },
  mutations: {
    refresh(state) {
      console.log("aa");

    },
    showletter(state, data) {

    }
  },
  actions: {}
};
